





























/* General */
import Vue from 'vue'
import MainContainer from '@/layouts/main-container.vue'
import DefaultLayout from '@/layouts/default-layout.vue'
import * as routerNames from '@/services/router/router.names'

/* Mixins */

/* Components */
import logoSrc from '@/assets/img/logos/logo-donedone.svg'

/* Helpers */

import RouteAssistant from '@/helpers/route-assistant'

/* Data types */

/* API */

export default Vue.extend({
  name: 'MailboxVerificationLayout',

  components: {
    MainContainer,
    DefaultLayout,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    showStartOverOption: {
      type: Boolean,
      default: false,
    },
    showCancelOption: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      logo: {
        src: logoSrc,
        alt: 'Logo DoneDone',
      },
      routerNames,
      serverSideAppUrl: process.env.VUE_APP_SERVER_SIDE_APP_URL,
    }
  },

  computed: {
    logoSize(): number {
      return this.$screen.isMobile(this.$mq) ? 28 : 32
    },
    notFirstScreen(): boolean {
      return this.$route.name !== routerNames.MAILBOX_VERIFICATION_INTRO
    },
  },

  methods: {
    goToMailbox() {
      RouteAssistant.goToMailbox(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
      )
    },
    goToVerificationSetup() {
      RouteAssistant.goToMailboxVerificationIntroRoute(
        this.$router,
        this.$route.params.accountId,
        this.$route.params.id,
      )
    },
  },
})
